// frontend/admin-portal/src/components/treasury/DefaultAccountBadge.jsx
import React, { useEffect, useState } from "react";
import { Badge } from "@fiberhome/shared-ui";
import { treasuryService } from "../../services/treasuryService";

/**
 * Shows which treasury account automatically receives inventory purchases.
 * Used in product/PO/receipt screens for clarity.
 */
export default function DefaultAccountBadge({ className = "" }) {
  const [account, setAccount] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let alive = true;
    treasuryService
      .listAccounts()
      .then((data) => {
        if (!alive) return;
        const accounts = data.accounts || [];
        const pick =
          accounts.find((a) => a.isDefault && a.isActive) ||
          accounts.find((a) => a.isActive) ||
          null;
        setAccount(pick);
      })
      .catch(() => setAccount(null))
      .finally(() => alive && setLoading(false));
    return () => {
      alive = false;
    };
  }, []);

  if (loading || !account) return null;

  return (
    <Badge variant="info" className={className}>
      Posts to: {account.name} ({account.currency})
    </Badge>
  );
}
